// PublicRoute.js
import React from "react";
import { Navigate } from "react-router-dom";
import FirebaseAuthHelper from "../../features/authentication/helpers/firebase-auth-helper/firebase-auth-helper";

const PublicRoute = ({ children }) => {
  const user = FirebaseAuthHelper.getCurrentUser();

  console.log('user :>> ', user);

  // Allow embed routes, api-docs, and signup routes to render even when authenticated
  const isPublicAccessRoute = (() => {
    if (typeof window === "undefined") return false;
    const path = window.location?.pathname || "";
    return path.startsWith("/embed/") || path === "/embed" || path.includes("/embed/") || path === "/api-docs" || path === "/qr-generator" || path.startsWith("/signup");
  })();
  if (user && !isPublicAccessRoute) {
    // If the user is authenticated, redirect to the dashboard
    return <Navigate to="/manage-groups" />;
  }

  return children;
};

export default PublicRoute;
